<p-menubar>
    <ng-template pTemplate="start">
        <button #menubutton class="p-link layout-menu-button layout-topbar-button" (click)="toggleSidebar()">
            <i class="pi pi-bars"></i>
        </button>
        <object data="assets/icons/nomoh_logo.svg" type="image/svg+xml"></object>
    </ng-template>
    <ng-template pTemplate="end">
            <div class="n-menubar-avatar" (click)="menu.toggle($event)">
                <p-avatar 
                    class=""
                    [image]="userAvatarUrl"
                    shape="circle" 
                    size="large"
                    [label]="userAvatarUrl ? '' : 'U'"
                    [style]="!userAvatarUrl ? {'background-color': '#1720c7', 'color': 'white'} : {}"/>
                <i class="pi pi-angle-down"></i>
                <p-tieredMenu #menu [model]="items" [popup]="true">
                    <ng-template class="n-menu-item" pTemplate="item" let-item (click)="mudarIdioma()">
                        <i class="{{ item.icon }}"></i>
                        <span>{{ item.label | translate }}</span>
                    </ng-template>
                </p-tieredMenu>
            </div>
    </ng-template>
</p-menubar>